import { useState, useEffect } from 'react';
import { userDataService } from '../services/UserDataService';
import { useAuthContext } from '../contexts/AuthContext';

/**
 * The viewer's continue-watching rail from `/v1/me/state/continue` (newest first). Each item is a
 * rail channel carrying `resumption_data` for the progress bar.
 */
export const useContinueWatching = () => {
  const [continueWatchingData, setContinueWatchingData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { isAuthenticated } = useAuthContext();

  useEffect(() => {
    let active = true;
    if (!isAuthenticated) {
      setContinueWatchingData([]);
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    setError(null);
    userDataService
      .refreshResumptionsData()
      .then(data => active && setContinueWatchingData(data['continue-watching']))
      .catch(err => {
        console.error('Error fetching continue watching data:', err);
        if (active) {
          setError("We couldn't load Continue Watching right now. Please try again.");
          setContinueWatchingData([]);
        }
      })
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [isAuthenticated]);

  return {
    continueWatchingData,
    loading,
    error,
    hasContinueWatching: continueWatchingData.length > 0,
  };
};
